import { AngularFireModule } from '@angular/fire/compat';
import { AngularFireRemoteConfigModule } from '@angular/fire/compat/remote-config';
import { environment } from '@env/environment';

export const remoteConfigModules = [
  AngularFireModule.initializeApp(environment.firebaseOptions),
  AngularFireRemoteConfigModule,
];
